// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".mobile-nav[data-v-950b920e]{height:calc(100vh - 64px)}@media (min-width:768px){.mobile-nav[data-v-950b920e]{height:calc(100vh - 96px)}}", ""]);
// Exports
module.exports = exports;
